import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Input, Layout, message, Modal, Popconfirm, Watermark} from "antd";
import {Content, Header} from "antd/es/layout/layout";
import copy from "copy-to-clipboard";
import axios from 'axios';
import Cookie from 'js-cookie';

import {FileAddOutlined, UserSwitchOutlined} from '@ant-design/icons';
import {useNavigate} from "react-router-dom";


const ChatUi = () => {


    const [data_mg1, setdata_mg1] = useState('');

    const [valu111e1, setdddvalue] = useState('');

    const [user_token_value1, setuser_token_value1] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        const usecookie = () => {
            if (Cookie.get('userToken_chattool') !== undefined) {

                console.log(Cookie.get('userToken_chattool'));


                //   setuser_token_value1(String(Cookie.get('userToken_chattool')))
                setuser_token_value1('1222');


            } else {
                navigate('/login');
            }
        };
        usecookie();
    }, []); // 空数组表示仅在组件挂载时执行


    const outlogin = () => {

        Cookie.remove('userToken_chattool');
        navigate('/login');


    }
    const post_data_usermess = new FormData();
    post_data_usermess.append('user_token', String(Cookie.get('userToken_chattool')));

    const [file_top_array, setFile_top_array] = useState('')
    const [copyadd_loading, setCopyadd_loading] = useState<boolean[]>([]);


    const [end_address, setend_address] = useState({url_address: '', success: ''})
    const [top_message_array, setTop_message] = useState([{

        id: '',
        file_name: '',
        path: '',
        address: '',
        file_state: '',
        loading_state: false


    }])

    const [top_value, setTop_value] = useState('');



    useEffect(() => {

        const formatdata_value = new FormData();
        formatdata_value.append('value1', 'top');


        const top_async_data = async () => {

            const top_data_1 = await fetch('https://api.chatv2.leytcn.com/Getfile_address/top_file_address.php', {
                method: 'POST'
                ,
                body: formatdata_value


            })


            const url_retrun = await top_data_1.json();

            setTop_message(url_retrun);

        }


        if (user_token_value1 !== '') {
            top_async_data();

        }


    }, [user_token_value1])


    // console.log(top_message_array);


    const onclick_debug = (value: any) => {


        setFile_top_array(value)


        if (end_address.url_address!==''){

let jjj=end_address.url_address;
            copy(end_address.url_address)
            message.success('复制成功');
        }
setTimeout(()=>{

    if (end_address.url_address!==''){

        copy(end_address.url_address)
message.success('复制成功');

    }


},3000)
    }


    useEffect(() => {


        const get_file_array = async () => {


            const data_da = await axios.get('http://114.115.170.169/keyactive/geturl_address/get_all_address.php?' + valu111e1)

            set_get_file_array_data(data_da.data)


        }


        if (valu111e1.length > 0) {
            get_file_array();
            console.log('this', get_file_array_data)


        }
    }, [valu111e1]);


    useEffect(() => {

        const file_post_data_formdata = new FormData();

        file_post_data_formdata.append('CN', file_top_array);
        const file_data_async = async () => {//创建一个async同步 赋值给file_data_async

            const data_await = await fetch('https://api.chatv2.leytcn.com/ChatUI/file_headeraddress.php', {
                method: 'POST',//方法
                body: file_post_data_formdata,//每个

            });


            const file_true_alladdress = await data_await.json();


                setend_address(file_true_alladdress);
              /*  copy(file_true_alladdress.url_address);
                message.success('复制成功');*/








        }


        if (file_top_array !== '') {


            file_data_async();


            // message.info('dd')
            setFile_top_array('');


        }


    }, [file_top_array])


    const post_value_num1 = new FormData();


    post_value_num1.append('device', '一');

    const data_async = async () => {

        const data_await = await fetch('https://api.chatv2.leytcn.com/ChatUI/flash_checkgroup.php', {
            method: "POST",

            body: post_value_num1,


        });


        const DJmm = await data_await.text();
        setdata_mg1(DJmm)
    }


    interface datadd {
        file_name: string;
        md5_message: string;
        sha1_message: string;
        url_address_en: string;
        url_realUrl: string;
    }


    //
    // const file_name=file_message[0]['file_name'];

    const [get_file_array_data, set_get_file_array_data] = useState({
        "file_name": "",
        "md5_message": "",
        "sha1_message": "",
        "url_address_en": "",
        "url_realUrl": ""
    });


    /*   const [top_message_array,setTop_message]=useState([])

   */


    const [panindex_file_list, setpanindex_file] = useState({
        data: {
            content: [{
                id: "c98bff37-b507-42aa-98c5-39922884d1a0",
                account_id: "",
                file_id: "",
                file_name: "",
                file_size: 0,
                size_fmt: "-",
                file_type: "",
                is_folder: true,
                last_op_time: "",
                parent_id: "",
                path: "",
                parent_path: "",
                thumbnail: "",
                download_url: "",
                view_type: "",
                create_time: "",
                is_delete: 1,
                hide: 0,
                has_pwd: 0,
                extra_data: null
            }], is_folder: '', last_file: "",
            next_file: "",
            no_referrer: false,
            page_no: 1,
            page_size: 10,
            pages: 1
        }, msg: '', status: ''
    });


    const panindex_form_data = new FormData();//创建一个formdata对象
    {
        panindex_form_data.append('path', '/Index/手机刷机/常用工具'); //为对象添加数        panindex_form_data.append('sort_by', '');
        panindex_form_data.append('order', '');
        panindex_form_data.append('page_no', '');
        panindex_form_data.append('page_size', '');

    }


    const debug_array = [{

        title: 'jj',
        value: '3311111111111111111111'

    }, {title: '111', value: '333j'}];
    const panindex_file_list_async = async () => {


        const panindex_file_list_wiat = await fetch('http://114.115.170.169:8069/api/v3/public/index', {
            method: "POST",

            body: panindex_form_data,


        });


        const push_message = await panindex_file_list_wiat.json();

        setpanindex_file(push_message);

        console.log(panindex_file_list);

    }


    // console.log(panindex_file_list);
    //  console.log(panindex_file_list[0]['center']);


    //   console.log(data_mg1, 'jjjj')




    const [top_modal_open, set_Top_modal_open] = useState(false);

    const add_file_top_button_onclick = () => {


        set_Top_modal_open(true);
        /*return(



        )*/

    }


    const [top_modal_dd, setTop_modal_dd] = useState('');

    const [top_return, settop_return] = useState('');

    useEffect(() => {

        const top_addup_data = async () => {

            const top_adddata_await = await fetch('https://api.chatv2.leytcn.com/ChatUI/top_addup_data.php', {

                method: 'POST',

                body: JSON.stringify(top_modal_dd)

            });
            const top_return_data = await top_adddata_await.json();

            settop_return(top_return_data);
        }


        if (top_modal_dd !== '') {

            top_addup_data();
            setTop_modal_dd('');

        }


    }, [top_modal_dd]);


    const [buttonLoadings, setButtonLoadings] = useState([]);

    const top_modal_ok = (value: any) => {

        set_Top_modal_open(false);


    }


    const [del_top_arr_data_v1, SetDel_top_arr_data_v1] = useState('');
    const [del_top_arr_data_v2, SetDel_top_arr_data_v2] = useState('');

    const [del_top_arr_data_v3, SetDel_top_arr_data_v3] = useState('');

    const post_send_data_del = new FormData();
    post_send_data_del.append('id', del_top_arr_data_v1);
    post_send_data_del.append('file_name', del_top_arr_data_v2);
    post_send_data_del.append('path', del_top_arr_data_v3);


    const del_top_message_data = (value1: any, value2: any, value3: any) => {


        console.log('要删除的数据', value2)
        SetDel_top_arr_data_v1(value1);
        SetDel_top_arr_data_v2(value2);
        SetDel_top_arr_data_v3(value3);


    }


    useEffect(() => {

        const async_del_top_message_data = async () => {


            const await_del_top_message_data = await fetch('https://api.chatv2.leytcn.com/Getfile_address/del_top_address.php', {
                method: 'POST',
                body: post_send_data_del,


            });

            const returen_data_del = await await_del_top_message_data.json();


        }

        if (del_top_arr_data_v1 !== '') {

            async_del_top_message_data();

            SetDel_top_arr_data_v1('');

        }


    }, [del_top_arr_data_v1]);


    const top_modal_mess = (value: any) => {

        console.log(value);
//console.log(top_modal_dd)

        setTop_modal_dd(value);

        set_Top_modal_open(false);
        message.success('添加成功');
    }


    return (





            <div style={{width: '100%', height: '100%', backgroundColor: '#f2f2f2f2'}}>


                    <div>

                        <div style={{margin: 10}}><label>置顶内容</label>

                            <FileAddOutlined onClick={add_file_top_button_onclick}
                                             style={{marginLeft: 10}}></FileAddOutlined>

                        </div>

                        <div>


                            <Input value={end_address.url_address !== '' ? end_address.url_address : ''}></Input>
                            <Button key={'copy_top'} style={{marginBottom: 30}}>复制</Button>
                        </div>
                        <Modal footer={null} open={top_modal_open} onOk={top_modal_ok} onCancel={top_modal_ok}
                               title={'添加路径'}>

                            <div>


                                <Form onFinish={top_modal_mess}>

                                    <label>标题</label>

                                    <Form.Item name={'title'} rules={[{required: true, message: 'Please input!'}]}>


                                        <Input key={'jj'} placeholder={'标题显示内容'}>
                                        </Input>

                                    </Form.Item>

                                    <label>路径</label>

                                    <Form.Item name={'path'} rules={[{required: true, message: 'Please input!'}]}>
                                        <Input key={'id11'}
                                               placeholder={'/Index/手机刷机/常用工具/FlashPhonetool/v3.2_20240107/'}>


                                        </Input>


                                    </Form.Item>


                                    <Form.Item name={'jj11'}>
                                        <Button type={'primary'} htmlType={'submit'}>
                                            提交


                                        </Button>


                                    </Form.Item>
                                </Form>


                            </div>


                        </Modal>


                        {top_message_array.map(item => (


                            <Card size={'small'} key={item.id} style={{fontSize: 1}} title={item.file_name}>
                                <div><Button
                                    key={item.id + 'kdk'} onClick={() => onclick_debug(item.path)}
                                    loading={item.loading_state} style={{marginLeft: 20}}>复制连接</Button><Popconfirm
                                    title={'是否确认删除' + '  ' + item.file_name}
                                    onConfirm={() => del_top_message_data(item.id, item.file_name, item.path)}
                                    key={item.id + 'jjj11'}> <Button style={{marginLeft: 10}}
                                                                     danger>Delete</Button></Popconfirm></div>
                            </Card>


                        ))}


                    </div>


            </div>


       );


}

export default ChatUi;